import { isHttpError } from '../query/root'
import { FieldError } from 'react-hook-form'

export type APIError = {
  [key: string]: Array<APIError> | Array<string> | APIError | string | null
}

interface SetError {
  (name: string, error: FieldError): void
}

const isRecord = (value: unknown): value is APIError =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

export const applyHttpFormErrors = (error: unknown, setError: SetError): void => {
  if (!isHttpError(error) || error.status !== 400 || !isRecord(error.data)) return
  setAPIErrors(error.data, setError)
}

export const setAPIErrors = (errors: APIError, setError: SetError, base = ''): void => {
  for (const [key, value] of Object.entries(errors)) {
    const newBase = base !== '' ? `${base}.${key}` : key

    if (key === 'non_field_errors' || key === 'common') {
      continue
    }

    if (Array.isArray(value)) {
      const firstMessage = value
        .map(item => {
          if (typeof item === 'string') {
            return item
          }
          if (item && typeof item === 'object' && 'message' in item) {
            const message = (item as { message?: unknown }).message
            return typeof message === 'string' ? message : null
          }
          return null
        })
        .find((item): item is string => Boolean(item))

      if (firstMessage) {
        setError(newBase, {
          type: 'manual',
          message: firstMessage
        })
        continue
      }

      value.forEach((entry, index) => {
        if (isRecord(entry)) {
          setAPIErrors(entry, setError, `${newBase}.${index}`)
        }
      })
    } else if (typeof value === 'string') {
      setError(newBase, {
        type: 'manual',
        message: value
      })
    } else if (isRecord(value)) {
      setAPIErrors(value, setError, newBase)
    }
  }
}
